<template>
  <v-app-bar-nav-icon class="ml-3 mr-5" :style="{ width: `${width}px` }" to="/home">
    <v-img :src="view.smallLogo" :aspect-ratio="16 / 9" contain max-height="32px" />
  </v-app-bar-nav-icon>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import eventBus from '../../services/eventBus';

const { mapGetters } = createNamespacedHelpers('account');
const { mapGetters: mapAppSettingsGetters } = createNamespacedHelpers('appSettings');

export default {
  data: function() {
    return {
      width: 102
    };
  },
  computed: {
    ...mapGetters(['canViewManagePanel', 'canViewHomePage']),
    ...mapAppSettingsGetters(['view']),
    manageActive() {
      return this.$route.path.startsWith('/manage');
    },
    homeActive() {
      return this.$route.path.startsWith('/home');
    }
  },
  mounted() {
    this.calculateImageWidth();
    eventBus.$on('smallLogoChanged', this.calculateImageWidth);
  },
  methods: {
    calculateImageWidth() {
      const image = new Image();
      image.src = this.view.smallLogo;
      image.onload = () => {
        this.width = image.width / (image.height / 32);
      };
    }
  }
};
</script>

<style scoped></style>
